import {BAG_TRANSPORT} from "../constants/service_types";
import {isEmpty} from "lodash";
import { findPhoneNumbersInText } from 'libphonenumber-js'

function extractEmails (text)
{
    return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
}

export const isValid = (entities) => {
    let invalidItem = null;
    let isValid = !Object.keys(entities.services).some(serviceId => {

        const service = entities.services[serviceId];
        if(service['type'] == BAG_TRANSPORT){
            let hike = service.hike
            if(!isEmpty(hike) && isEmpty(hike.id)){
                hike = entities.hikes[hike]
            }
            if(hike.isLMD){
                return service.items.some(itemId => {
                    const item = entities.items[itemId]
                    if(isEmpty(item.from.stop)){
                        let comment = item.departureLodgingInformation ? item.departureLodgingInformation : item.from.step.comment
                        if(comment){
                            let phoneNumbers = findPhoneNumbersInText(comment, 'FR');
                            let mails = extractEmails(comment);
                            if(/*isEmpty(phoneNumbers) && */isEmpty(mails)){
                                invalidItem = item
                                return true
                            }
                        } else {
                            invalidItem = item
                            return true
                        }
                    }
                    if(isEmpty(item.to.stop)){
                        let comment = item.arrivalLodgingInformation ? item.arrivalLodgingInformation : item.to.step.comment
                        if(comment){
                            let phoneNumbers = findPhoneNumbersInText(comment, 'FR');
                            let mails = extractEmails(comment);
                            if(/*!isEmpty(phoneNumbers) || */!isEmpty(mails)){
                                return false
                            }
                        }
                        invalidItem = item
                        return true
                    }
                    return false
                })
            }
        } return false;
    })

    return isValid ? true : invalidItem
}

export const isUpdateValid = (entities) => {
    let hasPendingService = Object.keys(entities.services).some(serviceId => {
        return entities.services[serviceId].items.some(itemId => {
            const item = entities.items[itemId]
            return !isEmpty(item.updateStatus)
        })
    })

    return hasPendingService;
}